import { configureStore } from "@reduxjs/toolkit";
import countryReducer from "@/store/modern/slices/countrySlice";
import inquiryReducer from "@/store/modern/slices/inquirySlice";
import portsReducer from "@/store/modern/slices/portSlice";
import promotionMediaReducer from "@/store/modern/slices/promotionMediaSlice";
import memberReducer from "@/store/modern/slices/memberSlice";
import galleryImageReducer from "@/store/modern/slices/newsAndEventSlice";
import productReducer from "@/store/modern/slices/productSlice";
import marketPlaceReducer from "@/store/modern/slices/marketPlaceSlice";
import UpgradePlanReqReducer from "@/store/modern/slices/requestslice";

export const rtkStore = configureStore({
    reducer: {
        countries: countryReducer,
        inquiries: inquiryReducer,
        ports: portsReducer,
        promotion_media: promotionMediaReducer,
        member: memberReducer,
        galleryImages: galleryImageReducer,
        products: productReducer,
        marketPlace: marketPlaceReducer,
        upgradeplanReq: UpgradePlanReqReducer
    },
    devTools: process.env.REACT_APP_SERVER_TYPE !== "production",
});

